/** True if the origin currently has persistent storage. Defensive — degrades
 *  to false on browsers without navigator.storage. */
export async function isPersistedStorage(): Promise<boolean> {
  const s = (navigator as Navigator).storage;
  if (s === undefined || typeof s.persisted !== "function") return false;
  try { return await s.persisted(); } catch { return false; }
}

/** Ask the browser for persistent storage. Native prompt may or may not show
 *  depending on browser heuristics. Returns true if granted. */
export async function requestPersistedStorage(): Promise<boolean> {
  const s = (navigator as Navigator).storage;
  if (s === undefined || typeof s.persist !== "function") return false;
  try { return await s.persist(); } catch { return false; }
}
